(function() {
  'use strict';

  angular
    .module('admin.channel_group.service', [])
    .factory('ChannelGroupService', ChannelGroupService);

  /** @ngInject */
  function ChannelGroupService($http, $q, API) {

    function list(start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channel_groups?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function get(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channel_groups/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/channel_groups', model)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function update(id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'admin/channel_groups/' + id, model)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/channel_groups/' + id)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function publish(id){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/channel_groups/' + id + '/publish')
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function unpublish(id){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/channel_groups/' + id + '/unpublish')
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    return{
        list: list,
        get: get,
        save: save,
        update: update,
        remove: remove,
        publish: publish,
        unpublish: unpublish
    };

  }

})();
